import React, {
  useEffect,
  useState
} from "react";

import AdminLayout from "./AdminLayout";

const AdminStudentTc = () => {
  /* =========================
     SESSION
  ========================= */
  const [sessionName, setSessionName] =
    useState("");

  const [sessions, setSessions] =
    useState([]);

  /* ADD CLASS SESSION */
  const [
    selectedSession,
    setSelectedSession
  ] = useState("");

  /* UPLOAD TC SESSION */
  const [
    selectedUploadSession,
    setSelectedUploadSession
  ] = useState("");

  /* =========================
     CLASS
  ========================= */
  const [className, setClassName] =
    useState("");

  const [cover, setCover] =
    useState(null);

  const [classes, setClasses] =
    useState([]);

  const [selectedClass, setSelectedClass] =
    useState("");

  /* =========================
     STUDENT
  ========================= */
  const [
    studentName,
    setStudentName
  ] = useState("");

  const [rollNo, setRollNo] =
    useState("");

  const [file, setFile] =
    useState(null);

  const [students, setStudents] =
    useState([]);

  /* =========================
     FETCH SESSIONS
  ========================= */
  const fetchSessions = () => {
    fetch(
      "https://kasiaweb.ilakshyaerp.in/api/student-tc/sessions"
    )
      .then((res) => res.json())
      .then((data) =>
        setSessions(
          Array.isArray(data)
            ? data
            : []
        )
      );
  };

  /* =========================
     FETCH CLASSES
  ========================= */
  const fetchClasses = (
    sessionId
  ) => {
    if (!sessionId) {
      setClasses([]);
      return;
    }

    fetch(
      `https://kasiaweb.ilakshyaerp.in/api/student-tc/classes/${sessionId}`
    )
      .then((res) => res.json())
      .then((data) =>
        setClasses(
          Array.isArray(data)
            ? data
            : []
        )
      );
  };

  /* =========================
     FETCH STUDENTS
  ========================= */
  const fetchStudents = (
    classId
  ) => {
    if (!classId) {
      setStudents([]);
      return;
    }

    fetch(
      `https://kasiaweb.ilakshyaerp.in/api/student-tc/class/${classId}`
    )
      .then((res) => res.json())
      .then((data) =>
        setStudents(
          Array.isArray(data)
            ? data
            : []
        )
      );
  };

  /* =========================
     LOAD FIRST TIME
  ========================= */
  useEffect(() => {
    fetchSessions();
  }, []);

  /* =========================
     ADD CLASS SESSION CHANGE
  ========================= */
  useEffect(() => {
    fetchClasses(
      selectedSession
    );
  }, [selectedSession]);

  /* =========================
     UPLOAD SESSION CHANGE
  ========================= */
  useEffect(() => {
    fetchClasses(
      selectedUploadSession
    );

    setSelectedClass("");
    setStudents([]);
  }, [selectedUploadSession]);

  /* =========================
     CLASS CHANGE
  ========================= */
  useEffect(() => {
    fetchStudents(
      selectedClass
    );
  }, [selectedClass]);

  /* =========================
     ADD SESSION
  ========================= */
  const addSession =
    async () => {
      if (!sessionName) {
        alert(
          "Enter Session"
        );
        return;
      }

      const res =
        await fetch(
          "https://kasiaweb.ilakshyaerp.in/api/student-tc/session/add",
          {
            method:
              "POST",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify(
              {
                session_name:
                  sessionName,
              }
            ),
          }
        );

      const data =
        await res.json();

      alert(
        data.message
      );

      setSessionName("");

      fetchSessions();
    };

  /* =========================
     ADD CLASS
  ========================= */
  const addClass =
    async () => {
      if (
        !selectedSession ||
        !className ||
        !cover
      ) {
        alert(
          "Fill all fields"
        );
        return;
      }

      const fd =
        new FormData();

      fd.append(
        "session_id",
        selectedSession
      );

      fd.append(
        "class_name",
        className
      );

      fd.append(
        "cover",
        cover
      );

      const res =
        await fetch(
          "https://kasiaweb.ilakshyaerp.in/api/student-tc/class/add",
          {
            method:
              "POST",
            body: fd,
          }
        );

      const data =
        await res.json();

      alert(
        data.message
      );

      setClassName("");
      setCover(null);

      fetchClasses(
        selectedSession
      );
    };

  /* =========================
     ADD TC
  ========================= */
  const addTc =
    async () => {
      if (
        !selectedUploadSession ||
        !selectedClass ||
        !studentName ||
        !file
      ) {
        alert(
          "Fill all fields"
        );
        return;
      }

      const fd =
        new FormData();

      fd.append(
        "class_id",
        selectedClass
      );

      fd.append(
        "student_name",
        studentName
      );

      fd.append(
        "roll_no",
        rollNo
      );

      fd.append(
        "file",
        file
      );

      const res =
        await fetch(
          "https://kasiaweb.ilakshyaerp.in/api/student-tc/tc/add",
          {
            method:
              "POST",
            body: fd,
          }
        );

      const data =
        await res.json();

      alert(
        data.message
      );

      setStudentName("");
      setRollNo("");
      setFile(null);

      fetchStudents(
        selectedClass
      );
    };

  /* =========================
     DELETE SESSION
  ========================= */
  const deleteSession =
    async (id) => {
      if (
        !window.confirm(
          "Delete Session?"
        )
      )
        return;

      await fetch(
        `https://kasiaweb.ilakshyaerp.in/api/student-tc/session/${id}`,
        {
          method:
            "DELETE",
        }
      );

      fetchSessions();
      setClasses([]);
      setStudents([]);
    };

  /* =========================
     DELETE CLASS
  ========================= */
  const deleteClass =
    async (id) => {
      if (
        !window.confirm(
          "Delete Class?"
        )
      )
        return;

      await fetch(
        `https://kasiaweb.ilakshyaerp.in/api/student-tc/class/${id}`,
        {
          method:
            "DELETE",
        }
      );

      fetchClasses(
        selectedSession
      );

      setStudents([]);
    };

  /* =========================
     DELETE TC
  ========================= */
  const deleteTc =
    async (id) => {
      if (
        !window.confirm(
          "Delete TC?"
        )
      )
        return;

      await fetch(
        `https://kasiaweb.ilakshyaerp.in/api/student-tc/tc/${id}`,
        {
          method:
            "DELETE",
        }
      );

      fetchStudents(
        selectedClass
      );
    };

  return (
    <AdminLayout>
      <div className="notice-page">

        {/* SESSION */}
        <div className="notice-card">
          <h2>
            Add Session
          </h2>

          <input
            placeholder="2025-2026"
            value={
              sessionName
            }
            onChange={(e) =>
              setSessionName(
                e.target.value
              )
            }
          />

          <button
            onClick={
              addSession
            }
          >
            Add Session
          </button>
        </div>

        {/* ADD CLASS */}
        <div className="notice-card">
          <h2>
            Add Class
          </h2>

          <select
            className="admin-select"
            value={
              selectedSession
            }
            onChange={(e) =>
              setSelectedSession(
                e.target.value
              )
            }
          >
            <option value="">
              Choose Session
            </option>

            {sessions.map(
              (s) => (
                <option
                  key={
                    s.id
                  }
                  value={
                    s.id
                  }
                >
                  {
                    s.session_name
                  }
                </option>
              )
            )}
          </select>

          <input
            placeholder="Class Name"
            value={
              className
            }
            onChange={(e) =>
              setClassName(
                e.target.value
              )
            }
          />

          <input
            type="file"
            onChange={(e) =>
              setCover(
                e.target
                  .files[0]
              )
            }
          />

          <button
            onClick={
              addClass
            }
          >
            Add Class
          </button>
        </div>

        {/* UPLOAD TC */}
        <div className="notice-card">
          <h2>
            Upload Student TC
          </h2>

          {/* SESSION */}
          <select
            className="admin-select"
            value={
              selectedUploadSession
            }
            onChange={(e) =>
              setSelectedUploadSession(
                e.target.value
              )
            }
          >
            <option value="">
              Choose Session
            </option>

            {sessions.map(
              (s) => (
                <option
                  key={
                    s.id
                  }
                  value={
                    s.id
                  }
                >
                  {
                    s.session_name
                  }
                </option>
              )
            )}
          </select>

          {/* CLASS */}
          <select
            className="admin-select"
            value={
              selectedClass
            }
            onChange={(e) =>
              setSelectedClass(
                e.target.value
              )
            }
          >
            <option value="">
              Choose Class
            </option>

            {classes.map(
              (c) => (
                <option
                  key={
                    c.id
                  }
                  value={
                    c.id
                  }
                >
                  {
                    c.class_name
                  }
                </option>
              )
            )}
          </select>

          <input
            placeholder="Student Name"
            value={
              studentName
            }
            onChange={(e) =>
              setStudentName(
                e.target.value
              )
            }
          />

          <input
            placeholder="Roll No"
            value={
              rollNo
            }
            onChange={(e) =>
              setRollNo(
                e.target.value
              )
            }
          />

          <input
            type="file"
            onChange={(e) =>
              setFile(
                e.target
                  .files[0]
              )
            }
          />

          <button
            onClick={
              addTc
            }
          >
            Upload TC
          </button>
        </div>

        {/* SESSION LIST */}
        <div className="notice-table">
          <h2>
            All Sessions
          </h2>

          <table>
            <tbody>
              {sessions.map(
                (s) => (
                  <tr
                    key={
                      s.id
                    }
                  >
                    <td>
                      {
                        s.session_name
                      }
                    </td>

                    <td>
                      <button
                        className="delete-btn"
                        onClick={() =>
                          deleteSession(
                            s.id
                          )
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

        {/* CLASS LIST */}
        <div className="notice-table">
          <h2>
            All Classes
          </h2>

          <table>
            <tbody>
              {classes.map(
                (c) => (
                  <tr
                    key={
                      c.id
                    }
                  >
                    <td>
                      {
                        c.class_name
                      }
                    </td>

                    <td>
                      <button
                        className="delete-btn"
                        onClick={() =>
                          deleteClass(
                            c.id
                          )
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

        {/* STUDENTS */}
        <div className="notice-table">
          <h2>
            Student TC List
          </h2>

          <table>
            <tbody>
              {students.map(
                (s) => (
                  <tr
                    key={
                      s.id
                    }
                  >
                    <td>
                      {
                        s.student_name
                      }
                    </td>

                    <td>
                      {
                        s.roll_no
                      }
                    </td>

                    <td>
                      <button
                        className="delete-btn"
                        onClick={() =>
                          deleteTc(
                            s.id
                          )
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminStudentTc;